import "@/assets/styles/layouts/Text.css";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// Components
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";

// Context
import { useManagedSpecialUnits } from "@/Motivators/context/SpecialUnits/ManagedContext";
import { useMotivators } from "@Motivators/context/Common/MotivatorsContext";

export default function ManagedUnitInput(props) {
	const [value, setValue] = useState(0);
	const [inputType, setInputType] = useState("Dollar");
	const { searchExist, dataSearch, updateData, setUpdateData } = useManagedSpecialUnits();
	const { isLoading } = useMotivators();
	const disableActions = !props?.dateRange?.from || !props?.dateRange?.to;

	const handleChangeType = (_valueData, input) => {
		setInputType(input);
		props.onChange({ error: !value, commission: { input, value } });
	};

	useEffect(() => {
		if (!isNaN(updateData) && value !== updateData) {
			setValue(updateData);
		}
	}, [updateData]);

	return (
		<InputFormExtension
			data={[
				{
					type: "Dollar",
					min: 0,
					max: 10000,
					decimalsEditable: true,
					decimals: 2,
				},
				{
					type: "Percent",
					min: 0,
					max: 100,
					decimalsEditable: true,
					decimals: 2,
				},
				{
					type: "Dollar per Unit",
					min: 0,
					max: 10000,
					decimals: 2,
					decimalsEditable: true,
				},
			]}
			value={value || 0}
			defaultType={inputType}
			sx={{ width: "80px" }}
			variant={"standard"}
			onActionUpdate={(value) => {
				const commissionAmount = +value;
				setValue(commissionAmount);
				setUpdateData(commissionAmount);
			}}
			onFocusOut={(newVal) => {
				props.onChange({ error: !newVal, commission: { input: inputType, value: +newVal } });
			}}
			onChangeType={handleChangeType}
			error={!searchExist && !value && dataSearch?.length}
			disabled={disableActions || isLoading || searchExist || dataSearch?.length === 0}
		/>
	);
}

ManagedUnitInput.propTypes = {
	dateRange: PropTypes.shape({
		from: PropTypes.string,
		to: PropTypes.string,
	}),
	onChange: PropTypes.func.isRequired,
};
